import { render } from "./CartHeaderChapter.vue?vue&type=template&id=5cf37824"
import script from "./CartHeaderChapter.vue?vue&type=script&lang=js"
export * from "./CartHeaderChapter.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__